import branchManagementDeletedShipmentsComponent from './deleted_shipments.component'

let branchManagementDeletedShipmentsModule = angular.module('branchManagementDeletedShipments', [])
    .component('branchManagementDeletedShipments', branchManagementDeletedShipmentsComponent)
    .name;

export default branchManagementDeletedShipmentsModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/deleted_shipments/index.js